import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
	fields: [],
	loading: false,
	error: ''
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
	case actionTypes.FETCH_FORM_FIELDS_BEGIN:
		return updateObject(state, {
			loading: true,
			error: ''
		});
	case actionTypes.FETCH_FORM_FIELDS_SUCCESS:
		return updateObject(state, {
			loading: false,
			fields: action.payload
		});
	case actionTypes.FETCH_FORM_FIELDS_FAILED:
		return updateObject(state, {
			loading: false,
			error: 'ERROR'
		});
	default:
		return state;
	}
};

export default reducer;
